//namespace Pacem {
export class DeferPromise {
    constructor() {
        this.deferred = null;
        var me = this;
        me.promise = new Promise(function (resolve, reject) {
            me.deferred = { 'resolve': resolve, 'reject': reject, 'promise': me };
        });
    }
    then(onCompleted, onFailed) {
        return this.promise.then(onCompleted, onFailed);
    }
    /**
     * Occurs whenever the promise concludes (either after completion or error).
     * @param {Function } callback
     */
    finally(callback) {
        this.promise.then(callback, callback);
        return this;
    }
    success(callback) {
        this.promise.then(callback, null);
        return this;
    }
    error(callback) {
        this.promise.then(null, callback);
        return this;
    }
    static defer() {
        var q = new DeferPromise();
        return q.deferred;
    }
}
//}
